import { connect } from 'react-redux';
import Chrome from './Chrome';
import getSessionId from '../../utils/session-selector';
import messages from './messages';
import { updateSession } from '../../actions/session';
import { showStreaksModal } from '../../actions/streaks';

const mapState = state => {
  const sessionId = getSessionId(state);
  const { fenderConnect, search, session, myProgress, favorites, flags } = state;
  const { alert } = favorites || {};
  const { isFavoritesEnabled } = flags || {};
  const { email, firstName, hasSubscription, loggedIn, sessionCheckComplete, subscriptions } =
    fenderConnect || {};
  const { markCompleteModalData } = myProgress || {};
  const { createdAt } = subscriptions || '';
  const { sessionData, sessionLengthInMins } = session || {};
  const { didSet, isVisible } = alert || {};
  return {
    createdAt,
    didSet,
    email,
    firstName,
    loggedIn,
    messages,
    markCompleteModalData,
    isVisible,
    isFavoritesEnabled: isFavoritesEnabled || false,
    hasSubscription: hasSubscription || false,
    searchQuery: search.results.query || '',
    sessionId,
    sessionCheckComplete,
    sessionData,
    sessionLengthInMins,
    subscriptions,
  };
};

const mapDispatch = {
  showStreaksModal,
  updateSession,
};

export default connect(mapState, mapDispatch)(Chrome);
